// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import {
  initializeFirestore,
  getFirestore,
  memoryLocalCache,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";

/** Safari 对 IndexedDB 持久化缓存兼容性较差，易导致 Firestore 查询一直 pending */
const isSafariBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPR|Edg/i.test(ua);
};
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCSCD06UCUkd26aWg9BTvyp80u462g6PAA",
  authDomain: "gh-home-bf859.firebaseapp.com",
  projectId: "gh-home-bf859",
  storageBucket: "gh-home-bf859.firebasestorage.app",
  messagingSenderId: "264013788166",
  appId: "1:264013788166:web:0ac1dd7d5368f4c2543f87",
  measurementId: "G-TVGJ66BFFN"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Safari 使用内存缓存，避免 IndexedDB 导致查询挂起；其他浏览器使用持久化缓存
function createFirestore() {
  if (isSafariBrowser()) {
    return initializeFirestore(app, { localCache: memoryLocalCache() });
  }
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
    });
  } catch {
    return getFirestore(app);
  }
}

export const db = createFirestore();